import { useEffect } from 'react';
import { useThemeStore, useThemeActions } from '../store/themeStore';

export const useTheme = () => {
  const { theme, appliedTheme } = useThemeStore(state => ({
    theme: state.theme,
    appliedTheme: state.appliedTheme,
  }));

  const { setAppliedTheme } = useThemeActions();

  useEffect(() => {
    // Helper function to detect system theme preference
    const getSystemTheme = (): 'light' | 'dark' => {
      return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
    };

    // Helper function to apply theme to document
    const applyTheme = (themeToApply: 'light' | 'dark') => {
      document.documentElement.setAttribute('data-theme', themeToApply);
      setAppliedTheme(themeToApply);
    };

    // Determine which theme to apply
    if (theme === 'system') {
      const systemTheme = getSystemTheme();
      applyTheme(systemTheme);

      // Listen for system theme changes
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = (e: MediaQueryListEvent) => {
        if (theme === 'system') {
          applyTheme(e.matches ? 'dark' : 'light');
        }
      };

      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    } else {
      // Apply the explicitly selected theme
      applyTheme(theme);
      return undefined;
    }
  }, [theme, setAppliedTheme]);

  return { theme, appliedTheme };
};
